<template>
  
    <div>
    <v-card class="card">
      <v-card-text class="pa-3">
        <line-chart :data="data1" xtitle="Time" ytitle="Order" :dataset="{borderWidth: 3}"/>
      </v-card-text>
    </v-card>
    <span>{{data1}}</span>
  </div>

</template>

<script>
export default {
  data() {
    return {
      data1: {}
    }
  },
  created(){
    console.log("CREATE")
      this.load_data()
  },
  methods:{
    load_data(){
        const vm = this;
        vm.axios.get('https://ws.plantifulbkk.shop/get_sale_chart.php').then(response => {
        //var result = JSON.parse(JSON.stringify(response.data))
        this.data1 = { "2020-09-15": 3 ,  "2020-09-16": 4}
        //this.data1 = JSON.parse(JSON.stringify(response.data))
        console.log(this.data1)
        });
    },
  }
}
</script>

<style>
  .card {
    border-radius: 3px;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/statistics/SiteViewStatistic.vue